'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/seperate.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _seperator = require('./seperator');
var _seperator2 = _interopRequireDefault(_seperator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
Seperate.propTypes = {
  children: (0, _propTypes.arrayOf)(_propTypes.node)
};
var truthy = function truthy(v) {
  return !!v;
};
function Seperate(_ref) {
  var _this = this;
  var children = _ref.children;
  var i = 0;
  return _react2.default.createElement(_glamorous.Div, {
    display: 'flex',
    alignItems: 'center',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  }, children.filter(truthy).map(function (child) {
    return child;
  }).reduce(function (acc, cur) {
    return cur ? [].concat(_toConsumableArray(acc), [cur, _react2.default.createElement(_seperator2.default, {
      key: 's_' + ++i,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      },
      __self: _this
    })]) : acc;
  }, []).slice(0, -1));
}
exports.default = Seperate;